import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

export default function TrainingTemplate() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable title="Chương trình huấn luyện" name="TrainingTemplate" />
        </Container>
      </div>
    </React.Fragment>
  );
}
